import GoogleAnalyticsService from "../../../lib/html5-software-library/src/ranj/analytics/GoogleAnalyticsService";
import GoogleAnalyticsCommand from './GoogleAnalyticsCommand';
import GoogleAnalyticsConfig from "./GoogleAnalyticsConfig";
import GoogleAnalyticsEvent from "./GoogleAnalyticsEvent";
import InitGoogleAnalyticsTask from "./InitGoogleAnalyticsTask";
import AbstractInstaller from "../core/application/AbstractInstaller";
import GoogleAnalyticsModel from "./GoogleAnalyticsModel";

export default class GoogleAnalyticsInstaller extends AbstractInstaller {
    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        injector.mapClass("googleAnalyticsService", GoogleAnalyticsService, true);
        injector.mapClass("googleAnalyticsConfig", GoogleAnalyticsConfig, true);
        injector.mapClass("googleAnalyticsModel", GoogleAnalyticsModel, true);

        commands.add(GoogleAnalyticsEvent.INIT, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.USER, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.PERSISTENT_VALUE, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.CLEAR_PERSISTENT_VALUE, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.EVENT, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.ERROR, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.SESSION_START, GoogleAnalyticsCommand);
        commands.add(GoogleAnalyticsEvent.SESSION_END, GoogleAnalyticsCommand);

        this._addStartupTask(InitGoogleAnalyticsTask, "initGA", 1);

        this._addDestroyEvents(GoogleAnalyticsEvent.SESSION_END);
    }
}